import { Box, Typography, Link } from '@castlery/fortress';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import { selectOrder } from '@castlery/modules-order-domain';
import { getGiftsByOrderNumberV2 } from '@castlery/modules-promotion-domain';
import Gift from './gift';
import type { CollapsibleContentProps } from '../types';
import type { Gift as GiftType } from '@castlery/types';
// TODO 这里要和 color 对齐模块的范围
// eslint-disable-next-line
import { ScrollWrapper } from '@castlery/shared-components';
import { PosChooseFreeGiftDeliveryModal } from '../../pos-chooseFreeGift-delivery-modal';

export const CollapsibleContent = ({ isOpen, mobileLayout, gifts, curCode }: CollapsibleContentProps) => {
  const [selectedGift, setSelectedGift] = useState<GiftType | null>(null);
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const dispatch = useAppDispatch();
  const order = useAppSelector(selectOrder);

  const handleChooseGift = (gift: GiftType) => {
    setSelectedGift(gift);
    setOpenDeliveryModal(true);
  };

  const handleCloseModal = (refresh = false) => {
    setOpenDeliveryModal(false);
    setSelectedGift(null);
    if (order?.number && refresh) {
      dispatch(getGiftsByOrderNumberV2.initiate({ orderNumber: order.number }));
    }
  };

  return (
    <Box
      sx={{
        maxHeight: isOpen ? 1000 : 0,
        overflow: 'hidden',
        transition: 'all 0.5s ease-in-out',
      }}
    >
      <Typography level="caption1" sx={{ my: 2 }}>
        Note: Gifts are subject to stock availability.
        <Link
          component="button"
          underline="always"
          sx={{
            color: 'var(--fortress-palette-brand-burntOrange-500) !important',
            textDecorationColor: 'var(--fortress-palette-brand-burntOrange-500) !important',
          }}
          onClick={() => {
            window.open('https://www.castlery.com/promo-terms', '_blank');
          }}
        >
          T&Cs apply.
        </Link>
      </Typography>

      <ScrollWrapper
        scrollTrackHeight={8}
        sx={{
          py: 0,
          gap: 2,
          '& > .MuiStack-root': {
            marginTop: '0 !important',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: 1,
          }}
        >
          {gifts?.map((gift) => (
            <Gift key={gift.id} gift={gift} mobileLayout={mobileLayout} posSlectDeliveryModal={handleChooseGift} />
          ))}
        </Box>
      </ScrollWrapper>

      {/* 统一的 Modal 管理 */}
      <PosChooseFreeGiftDeliveryModal
        open={openDeliveryModal}
        onClose={handleCloseModal}
        gift={selectedGift}
        code={curCode}
      />
    </Box>
  );
};
